<template>
  <div class="flex flex-col">
    <v-date-picker
      ref="datepicker"
      class="datepicker"
      :class="{'disabled-datepicker': $attrs.disabled}"
      :popup-class="{
        'month-only-no-nav': hideYearLabel
      }"
      v-bind="$attrs"
      v-on="$listeners"
      :min="min"
      :max="max"
      :clearable="clearable"
      :input-attr="inputAttr"
      @change="(value) => change(value)"
      :disabled-date="customDisabledDate || disabledDate"
    >
      <template slot="icon-calendar">
        <img
          :src="require('@/assets/shipo-date-picker-icon-calendar.svg')"
          :width="imgSize"
        >
      </template>
    </v-date-picker>
    <span
      v-if="!isValid"
      class="text-danger"
      style="font-size: .65rem;"
    >* Required</span>
  </div>
</template>

<script>
import VDatePicker from 'vue2-datepicker'

export default {
  name: 'DatePicker',
  props: {
    imgSize: {
      type: Number,
      default: () => 24
    },
    label: {
      type: String,
      default: ''
    },
    isValid: {
      type: Boolean,
      default: () => true
    },
    min: {
      type: [String, Date],
      default: ''
    },
    max: {
      type: [String, Date],
      default: ''
    },
    customDisabledDate: {
      type: Function,
      default: null
    },
    change: {
      type: Function,
      default: () => false
    },
    clearable: {
      type: Boolean,
      default: () => true
    },
    inputAttr: {
      type: Object,
      default: () => ({})
    },
    hideYearLabel: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    VDatePicker
  },
  watch: {
    isValid: {
      handler(val) {
        if (!this.$attrs.disabled) {
          if (val) {
            this.$refs.datepicker.$el.classList.remove('mx-input-danger')
            return
          }

          this.$refs.datepicker.$el.classList.add('mx-input-danger')
          return
        }

        this.$refs.datepicker.$el.classList.remove('mx-input-danger')
      }
    }
  },
  methods: {
    disabledDate(date) {
      const minDate = this.min ? new Date(this.min) : null
      const maxDate = this.max ? new Date(this.max) : null
      if (minDate && date < minDate) return true
      if (maxDate && date > maxDate) return true
      return false
    }
  },
  mounted() {
    // create label
    if (this.label) {
      const label = document.createElement('label')
      label.classList.add('datepicker-label')
      label.innerHTML = this.label
      this.$refs.datepicker.$el.insertBefore(label, this.$refs.datepicker.$el.firstChild)
    }

    // add listener for focus in and focus out style
    const input = this.$refs.datepicker.$refs.input
    input.addEventListener('focusin', (event) => {
      event.target.parentElement.setAttribute('focus', 'focus')
    })
    input.addEventListener('focusout', (event) => {
      event.target.parentElement.removeAttribute('focus')
    })
    this.$refs.datepicker.$el.lastChild.addEventListener('click', (event) => {
      const input = event.target.closest('.mx-input-wrapper').firstChild
      input.focus()
    })
  }
}
</script>

<style lang="scss" scoped>
// `mx-input-wrapper` is `div` class, `div` doesn't have `disabled` selector
// `disabled` selector should be explicitly set to `true`
.disabled-datepicker {
  /deep/ .mx-input-wrapper {
    background-color: #ECEBED !important;
  }

  img {
    filter: grayscale(100%);
  }
}

.datepicker {
  @apply w-full #{!important};

  /deep/ .datepicker-label {
    @apply inline-block;
    @apply text-sm;
    @apply font-semibold;
    @apply text-grey;
    @apply p-0;
    @apply mb-1;
  }

  /deep/ .mx {
    &-input {
      @apply bg-transparent;
      @apply border-none;
      @apply outline-none;
      @apply shadow-none;
      @apply p-0;
      @apply text-base;
      @apply font-normal;
      @apply truncate;
      height: calc(1rem * 4 / 3);

      &::-webkit-input-placeholder { /* Edge */
        @apply p-0;
      }

      &:-ms-input-placeholder { /* Internet Explorer 10-11 */
        @apply p-0;
      }

      &::placeholder {
        @apply p-0;
      }

      &:disabled {
        @apply text-black;
        background-color: #ECEBED;
      }

      &-wrapper {
        @apply py-4;
        @apply pl-5;
        @apply rounded-lg;
        padding-right: calc(1rem + 24px);
        background-color: #F1F1FD;

        &[focus="focus"] {
          outline: 2px solid #493493;
        }
      }
    }

    &-icon {
      &-calendar,
      &-clear {
        right: 0.5rem;
      }

      &-clear svg {
        fill: #493493;
        width: 2rem;
        height: 2rem;
      }
    }
  }
}

.mx-input-danger {
  @apply border-2 border-danger rounded-lg;
}
</style>
